import { useTranslation } from 'react-i18next';
import { SmallButton } from 'components/Shared/Buttons';
import { colors, screen } from 'components/styles/variables';

interface EmptyReviewsCTAProps {
  link: string;
  locationDisplayName?: string;
  header?: string | null;
}

export default function EmptyReviewsCTA({
  link,
  locationDisplayName,
  header,
}: EmptyReviewsCTAProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      {locationDisplayName ? (
        <h2 className="section-header">
          {locationDisplayName} {t('seoSrp.dealerReviews.header')}
        </h2>
      ) : null}
      {header ? <h2 className="section-header">{header}</h2> : null}
      <div className="no-reviews-container">
        <div className="no-reviews-header">{t('seoSrp.dealerReviews.noReviews.header')}</div>
        <div className="button-container">
          <SmallButton
            className="write-review-button"
            href={link}
            target="_blank"
            buttonColor="blue"
            disabled={true}
          >
            {t('seoSrp.dealerReviews.noReviews.button')}
          </SmallButton>
        </div>
      </div>
      <style jsx>{`
        .section-header {
          font-weight: 700;
          font-size: 20px;
          line-height: 26px;
          letter-spacing: 0.2px;
          text-transform: uppercase;
          color: ${colors.BLACK};
          margin-top: 24px;
        }
        @media screen and (max-width: ${screen.mdMax}) {
          .section-header {
            padding: 0 24px 0 24px;
          }
        }
        @media screen and (min-width: ${screen.smMin}) and (max-width: ${screen.mdMax}) {
          .section-header {
            padding-left: 24px;
          }
        }
        .no-reviews-container {
          border-radius: 8px;
          border: 1px solid ${colors.G2};
          padding: 72px 24px;
          margin: 24px 0;
          display: flex;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          flex-wrap: wrap;
        }
        @media screen and (max-width: 849px) {
          .no-reviews-container {
            margin: 24px 10px;
          }
        }
        .no-reviews-header {
          font-size: 18px;
          font-weight: 700;
          line-height: 22px;
          letter-spacing: 0.2px;
          text-align: center;
        }
        .button-container {
          margin-top: 44px;
          display: flex;
          justify-content: center;
        }
      `}</style>
    </>
  );
}
